import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/serviceWorkerRegistration";
import { installEntityHeaderInterceptor } from "@/lib/entityContext";

installEntityHeaderInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker (offline support, app-shell caching, install prompt)
registerServiceWorker();
